import api, { BodyData } from '../../../utils/api';
import {EmailNotificationSettingsFormData} from './fetchEmailNotificationSettings';
import stringToBoolean from '../../../componentsNew/utils/stringToBoolean';

export interface SaveEmailNotificationSettingsPayload extends BodyData {
    readonly viewingNotificationRecipientGroup: string;
    readonly viewingPlannedNotificationEnabled: boolean;
    readonly viewingRejectedNotificationEnabled: boolean;
    readonly viewingRescheduledNotificationEnabled: boolean;
    readonly viewingAttendanceListEnabled: boolean;
}

const emailNotificationSettingsFormDataToPayload = (data: EmailNotificationSettingsFormData): SaveEmailNotificationSettingsPayload => {
    return {
        viewingNotificationRecipientGroup: stringToBoolean(data.viewingNotificationRecipientGroup),
        viewingPlannedNotificationEnabled: stringToBoolean(data.viewingPlannedNotificationEnabled),
        viewingRejectedNotificationEnabled: stringToBoolean(data.viewingRejectedNotificationEnabled),
        viewingRescheduledNotificationEnabled: stringToBoolean(data.viewingRescheduledNotificationEnabled),
        viewingAttendanceListEnabled: stringToBoolean(data.viewingAttendanceListEnabled),
    }
}

const saveEmailNotificationSettings = async (data: EmailNotificationSettingsFormData): Promise<void> => {
    const payload = emailNotificationSettingsFormDataToPayload(data);
    await api.post(`api/agency/${data.agencyId}/preferences/communication/save`, payload);
}

export default saveEmailNotificationSettings;
